import { render } from "./ContentTeam.vue?vue&type=template&id=1a2e0087&scoped=true"
import script from "./ContentTeam.vue?vue&type=script&lang=js"
export * from "./ContentTeam.vue?vue&type=script&lang=js"

import "./ContentTeam.vue?vue&type=style&index=0&id=1a2e0087&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src895191040/src/tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2e0087"]])

export default __exports__